export default __webpack_public_path__ + "static/media/img14.6e86e918.PNG";